/*
 * Terms of Use gate — see snippets/terms-gate.liquid for the text, modes and storage.
 * Plain JS (no Vue) so the gallery page and the product-page project pop-ups share
 * one implementation.
 */
(function () {
  if (window.wfTermsGate) return;

  var tpl = document.querySelector('template[data-terms-gate]');
  if (!tpl) return;
  window.wfTermsGate = true;

  var version = tpl.dataset.version;
  var apiBase = tpl.dataset.apiBase;
  var email = tpl.dataset.viewerEmail || '';
  var mode = tpl.dataset.mode;
  var storeKey = 'wf_terms_agreed:' + (email ? email.toLowerCase() : 'guest');

  var accepted = false;
  var waiting = null; // the in-flight ensureAccepted() promise

  function readStored() {
    try { return window.localStorage.getItem(storeKey) || ''; } catch (e) { return ''; }
  }

  function writeStored() {
    try { window.localStorage.setItem(storeKey, version); } catch (e) {}
  }

  function done() {
    accepted = true;
    document.documentElement.classList.remove('wf-terms-check');
  }

  // Resolves { agreed, outdated }. Signed-in customers fall back to their account
  // record when this browser has no note of it (a new device); a failed lookup counts
  // as not agreed, so the pop-up shows rather than the gate silently opening.
  function checkAgreed() {
    var stored = readStored();
    if (stored === version) return Promise.resolve({ agreed: true });

    if (!email) return Promise.resolve({ agreed: false, outdated: stored !== '' });

    var query = new URLSearchParams({ email: email, version: version });
    return fetch(apiBase + '/terms-status?' + query.toString())
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.agreed) writeStored();
        return { agreed: !!data.agreed, outdated: !!data.outdated };
      })
      .catch(function () { return { agreed: false, outdated: stored !== '' }; });
  }

  function showDialog(outdated) {
    return new Promise(function (resolve) {
      var dialog = document.createElement('dialog');
      dialog.className = 'terms-gate';
      dialog.setAttribute('aria-label', 'Terms of Use');

      var inner = document.createElement('div');
      inner.className = 'terms-gate__inner';

      var body = document.createElement('div');
      body.className = 'terms-gate__body';
      if (outdated) {
        var notice = document.createElement('p');
        notice.className = 'terms-gate__notice';
        notice.textContent = "We've updated our Terms of Use. Please review them and accept to continue.";
        body.appendChild(notice);
      }
      var text = document.createElement('div');
      // The store's own page content (not user input).
      text.innerHTML = tpl.innerHTML;
      body.appendChild(text);

      var error = document.createElement('p');
      error.className = 'terms-gate__error';
      error.setAttribute('role', 'alert');
      error.hidden = true;

      var actions = document.createElement('div');
      actions.className = 'terms-gate__actions';
      var agree = document.createElement('button');
      agree.type = 'button';
      agree.className = 'btn btn--primary';
      agree.textContent = 'Accept';
      var decline = document.createElement('button');
      decline.type = 'button';
      decline.className = 'btn btn--secondary';
      decline.textContent = 'Decline';
      actions.appendChild(agree);
      actions.appendChild(decline);

      inner.appendChild(body);
      inner.appendChild(error);
      inner.appendChild(actions);
      dialog.appendChild(inner);
      document.body.appendChild(dialog);

      // No Escape / backdrop dismissal — closing would be a way round accepting.
      dialog.addEventListener('cancel', function (event) { event.preventDefault(); });

      decline.addEventListener('click', function () {
        window.location.href = '/';
      });

      agree.addEventListener('click', function () {
        function finish() {
          writeStored();
          dialog.close();
          dialog.remove();
          resolve();
        }

        if (!email) {
          finish();
          return;
        }

        agree.disabled = true;
        decline.disabled = true;
        error.hidden = true;
        fetch(apiBase + '/terms-agree', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email, version: version }),
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw new Error(data.error || 'Something went wrong. Please try again.');
            });
          })
          .then(finish)
          .catch(function (e) {
            error.textContent = e.message || 'Something went wrong. Please try again.';
            error.hidden = false;
            agree.disabled = false;
            decline.disabled = false;
          });
      });

      dialog.showModal();
    });
  }

  function ensureAccepted() {
    if (accepted) return Promise.resolve();
    if (waiting) return waiting;

    waiting = checkAgreed()
      .then(function (status) {
        return status.agreed ? null : showDialog(status.outdated);
      })
      .then(function () {
        done();
        waiting = null;
      });
    return waiting;
  }

  if (mode === 'page') {
    ensureAccepted();
    return;
  }

  // 'click' mode: hold the first project open until the terms are accepted, then
  // replay it. Capture phase on the document so it runs before the section's own
  // click handler.
  document.addEventListener(
    'click',
    function (event) {
      if (accepted) return;
      var trigger = event.target.closest('[data-project-open]');
      if (!trigger) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      ensureAccepted().then(function () { trigger.click(); });
    },
    true
  );
})();
